"use client";

import { FeatureHighlight } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import Image from "next/image";
import {
  matterportTourPreview,
  onSite,
} from "../../../../public/images/measurement-service";

const MATTERPORT_TOUR_URL = "https://my.matterport.com/show/?m=4rx5GCFJbWM";

const ServiceInfo = () => {
  const t = useTranslations("measurementService.serviceInfo");

  return (
    <div className="gs--page-column py-16">
      <div className="flex flex-col gap-10 lg:flex-row lg:items-start">
        <div className="flex-1">
          <FeatureHighlight
            src={onSite}
            alt={"Verkaufsoptimierter Grundriss Detail"}
            title={t("title")}
            text={t("text")}
            subText={t("subText")}
          />
        </div>
        <a
          href={MATTERPORT_TOUR_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full max-w-md self-center transition-opacity hover:opacity-90 lg:max-w-sm lg:self-start xl:max-w-md"
        >
          <Image
            src={matterportTourPreview}
            alt={t("matterportAlt")}
            className="h-auto w-full"
            sizes="(min-width: 1024px) 28rem, 100vw"
          />
        </a>
      </div>
    </div>
  );
};

export default ServiceInfo;
